import { Api } from "@/api/Api"


export function apiCustom() {

     const api = async (type = 'get', url, body = {})=> {
            let result = {}
            await Api[type](url, body).then(
                response => {
                    result = {
                        status: 'positive',
                        mess: response.data.message,
                        response: response.data
                    }
                }
            ).catch(response => {
                result = {
                    status: 'negative',
                    mess: response.code==='ERR_NETWORK'? [response.message + " " + response.code," não foi possivel conectar ao servidor "] : Array.isArray(response.response.data.message) ? [ ...response.response.data.message]: [response.response.data.message]
                }
            })
            return result;
        }
    return {
        api
    }
}